import { configureStore } from "@reduxjs/toolkit";

// Slices
import { globalSlice } from "../globalSlice/globalSlice";
import { loginSlice } from "../../containers/LoginForm/LoginFormSlice";

import { predefinedMenusSlice } from '../../components/PredefinedMenus/PredefinedMenusSlice'
import { addMaterialSlice } from '../../containers/Materials/AddModal/AddModalSlice'

import { materialsSlice } from "../../containers/Materials/MaterialsSlice";
import { showMaterialSlice } from "../../containers/Materials/ShowModal/ShowModalSlice";
import { addServiceSlice } from "../../containers/Services/AddModal/AddModalSlice";
import { showServiceSlice } from "../../containers/Services/ShowModal/ShowModalSlice";
import { servicesSlice } from "../../containers/Services/ServicesSlice";
import { addProductSlice } from "../../containers/Pricing/AddModal/AddModalSlice";
import { productsSlice } from "../../containers/Pricing/PricingSlice";

import { rolesSlice } from "../../containers/Roles/RolesSlice";
import { addRoleSlice } from "../../containers/Roles/AddModal/AddModalSlice";
import { permissionsSlice } from "../../containers/Roles/Permissions/PermissionsSlice";
import { showRoleSlice } from "../../containers/Roles/ShowModal/ShowModalSlice";
import { usersSlice } from "../../containers/Users/UsersSlice";
import { addUserSlice } from "../../containers/Users/AddModal/AddModalSlice";
import { employeesSlice } from "../../containers/Employees/EmployeesSlice";
import { addEmployeeSlice } from "../../containers/Employees/AddModal/AddModalSlice";
import { clientsSlice } from "../../containers/Clients/ClientsSlice";
import { addClientSlice } from "../../containers/Clients/AddModal/AddModalSlice";
import { showClientSlice } from "../../containers/Clients/ShowModal/ShowModalSlice";
import { suppliersSlice } from "../../containers/Suppliers/SuppliersSlice";
import { addSupplierSlice } from "../../containers/Suppliers/AddModal/AddModalSlice";
import { showSupplierSlice } from "../../containers/Suppliers/ShowModal/ShowModalSlice";
import { ordersSlice } from "../../containers/Orders/OrdersSlice";

import { billsSlice } from "../../containers/Bills/BillsSlice";

import { receiptVouchersSlice } from "../../containers/ReceiptVouchers/ReceiptVouchersSlice";
import { showReciptVoucherSlice } from "../../containers/ReceiptVouchers/ShowModal/ShowModalSlice";
import { addReceiptVoucherSlice } from "../../containers/ReceiptVouchers/AddModal/AddModalSlice";
import { paymentVouchersSlice } from "../../containers/PaymentVouchers/PaymentVouchersSlice";
import { addPaymentVoucherSlice } from "../../containers/PaymentVouchers/AddModal/AddModalSlice";
import { showPaymentVoucherSlice } from "../../containers/PaymentVouchers/ShowModal/ShowModalSlice";
import { editProfileSlice } from "../../containers/EditProfile/EditProfileSlice";
import { showProductSlice } from "../../containers/Pricing/ShowModal/ShowModalSlice";

import { salariesSlice } from "../../containers/Employees/Salaries/SalariesSlice";

import { orderSlice } from "../../containers/Order/OrderSlice";
import { materialPricingSlice } from "../../containers/Materials/MaterialPricing/MaterialPricingSlice";
import { editMaterialPricingSlice } from "../../containers/Materials/EditMaterialPricing/EditMaterialPricingSlice";
import { editServicePricingSlice } from "../../containers/Services/EditServicePricing/EditServicePricingSlice";
import { servicePricingSlice } from "../../containers/Services/ServicePricing/ServicePricingSlice";
import { addPriceSlice } from "../../containers/Pricing/AddPrice/AddPriceSlice";
import { editPricingSlice } from "../../containers/Pricing/EditPricing/EditPricingSlice";
import {purchaseBillSlicer} from '../../containers/purchases/bills/billSlice'
import {purchaseOrdersSlice} from '../../containers/purchases/orders/orderSlice'
import {companySlice} from '../../containers/Company/CompanySlice'
import {expensesTypesSlice} from '../../containers/ExpensesType/ExpensesTypeSlicer'
import {addExpenseTypeSlice} from '../../containers/ExpensesType/AddModal/AddModalSlice'
import {showExpensesTypeSlice} from '../../containers/ExpensesType/ShowModal/ShowModalSlice'
const reducer = {
    global: globalSlice.reducer,
    login: loginSlice.reducer,
    predefined_menus: predefinedMenusSlice.reducer,
    materials: materialsSlice.reducer,
    add_material: addMaterialSlice.reducer,
    show_material: showMaterialSlice.reducer,
    services: servicesSlice.reducer,
    add_service: addServiceSlice.reducer,
    show_service: showServiceSlice.reducer,
    add_product: addProductSlice.reducer,
    show_product: showProductSlice.reducer,
    products: productsSlice.reducer,

    roles: rolesSlice.reducer,
    add_role: addRoleSlice.reducer,
    show_role: showRoleSlice.reducer,
    permissions: permissionsSlice.reducer,
    users: usersSlice.reducer,
    add_user: addUserSlice.reducer,
    employees: employeesSlice.reducer,
    add_employee: addEmployeeSlice.reducer,
    salaries: salariesSlice.reducer,
    clients: clientsSlice.reducer,
    add_client: addClientSlice.reducer,
    show_client: showClientSlice.reducer,
    suppliers: suppliersSlice.reducer,
    add_supplier: addSupplierSlice.reducer,
    show_supplier: showSupplierSlice.reducer,
    orders: ordersSlice.reducer,
    order: orderSlice.reducer,

    bills: billsSlice.reducer,

    receipt_vouchers: receiptVouchersSlice.reducer,
    add_receipt_voucher: addReceiptVoucherSlice.reducer,
    show_receipt_voucher: showReciptVoucherSlice.reducer,
    payment_vouchers: paymentVouchersSlice.reducer,
    add_payment_voucher: addPaymentVoucherSlice.reducer,
    show_payment_voucher: showPaymentVoucherSlice.reducer,
    edit_profile: editProfileSlice.reducer,

    material_pricing: materialPricingSlice.reducer,
    edit_material_pricing: editMaterialPricingSlice.reducer,
    edit_service_pricing: editServicePricingSlice.reducer,
    service_pricing: servicePricingSlice.reducer,
    add_price: addPriceSlice.reducer,
    edit_pricing: editPricingSlice.reducer,
    purchaseOrder:purchaseOrdersSlice.reducer,
    purchaseBill:purchaseBillSlicer.reducer,
    company:companySlice.reducer,
    expenses_type : expensesTypesSlice.reducer,
    add_expenses_type:addExpenseTypeSlice.reducer,
    show_expenses_type:showExpensesTypeSlice.reducer
}

export default configureStore({
    reducer,
    devTools: process.env.NODE_ENV !== 'production'
})